/**
 * Pure H OS · Sprint 12 · Workspace mocks — types + live views.
 * Payload now lives in MongoDB `pureh_*` collections.
 * Note: `TASKS` name-collides with marketingData; workspace tasks are
 * stored under the fixtures key `workspace_tasks`.
 */
import { liveArray } from "../services/store";

export type Task = {
  id: string;
  title: string;
  owner: string;
  assignedBy: string;
  dueRelative: string;
  status: "todo" | "in-progress" | "review" | "done";
  priority: "low" | "medium" | "high";
  module: "R&D" | "Ops" | "Marketing" | "Commerce" | "Finance" | "Launch" | "Workspace";
  linkedTo?: string;
};
export const TASKS: Task[] = liveArray<Task>("workspace_tasks");

export type Person = {
  id: string;
  name: string;
  role: string;
  team: "R&D" | "Ops" | "Marketing" | "Digital" | "Sales" | "Finance" | "Executive" | "Retail";
  location: string;
  joinedRelative: string;
  status: "active" | "on-leave" | "onboarding";
  utilisation: number;
};
export const PEOPLE: Person[] = liveArray<Person>("people");

export type WsFile = {
  id: string;
  name: string;
  kind: "brief" | "formula" | "coa" | "contract" | "invoice" | "creative" | "regulatory" | "other";
  size: string;
  owner: string;
  updatedRelative: string;
  tags: string[];
};
export const WS_FILES: WsFile[] = liveArray<WsFile>("ws_files");

export type AuditEntry = {
  id: string;
  actor: string;
  action: string;
  target: string;
  module: string;
  whenRelative: string;
  severity: "info" | "warn" | "critical";
};
export const AUDIT_LOG: AuditEntry[] = liveArray<AuditEntry>("audit_log");
